import Config from 'app/config';

export default (redirectPath = '/') => {
  const accountHost = Config.get('ACCOUNT_HOST');
  const signUrl = `${window.location.origin}/sign`;
  const redirectUrl = `${window.location.origin}/${redirectPath}`;

  window.location.assign(`${accountHost}/signup?signUrl=${signUrl}&url=${redirectUrl}`);
};
